import getNestedProducts from "./getNestedProducts";
import type { TileOptionSelections } from "../types";

const fetchRidgeAccessories = async ({
  tileOptions,
  setTileOptions,
  esIndexNameProduct
}: {
  tileOptions?: TileOptionSelections;
  setTileOptions: (tileOptionSelections?: TileOptionSelections) => void;
  esIndexNameProduct?: string;
}) => {
  if (!esIndexNameProduct) {
    return;
  }

  if (tileOptions?.ridge?.productReferences?.length) {
    const ridgeReferencesToFetch = tileOptions.ridge.productReferences;

    try {
      const nestedProducts = await getNestedProducts(
        ridgeReferencesToFetch,
        esIndexNameProduct
      );

      if (!nestedProducts) {
        return;
      }

      const { ridgeEnd, ridgeStart, yRidge, tRidge } = nestedProducts;
      setTileOptions({
        ...tileOptions,
        ridge: { ...tileOptions.ridge, ridgeEnd, ridgeStart, yRidge, tRidge }
      });
    } catch (err: any) {
      console.error(
        `Did not manage to fetch the following ridge tile product references - ${JSON.stringify(
          ridgeReferencesToFetch
        )}\n${err.message}`
      );
    }
  }
};

export default fetchRidgeAccessories;
